import { render } from "./ProcesoLegal.vue?vue&type=template&id=09d32bc6&scoped=true"
import script from "./ProcesoLegal.vue?vue&type=script&lang=js"
export * from "./ProcesoLegal.vue?vue&type=script&lang=js"

import "./ProcesoLegal.vue?vue&type=style&index=0&id=09d32bc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d32bc6"]])

export default __exports__